module.exports = __webpack_public_path__ + "static/media/menuHeadset.1e2e0f00.svg";